import React, { Component } from "react";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import { Button as RSButton, Collapse as RSCollapse, Card, CardBody } from 'reactstrap';
import { Table, TableHead, TableBody, TableRow, TableCell, Paper, Collapse, Button, TablePagination } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import { setError, setSuccess, setLoader } from "../../../actions/action-creators";
import InputFeild from "../../global/form/input"
import SelectList from "../../global/form/select"
import UserCard from "../user_profile/user_card";
import moment from "moment";

const isRosterActive = (row) => !row.end_date || moment(row.end_date).isAfter(moment());

class ManageFieldWorkers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            partners: [],
            isOpenAssignPartner: false,
            mobile: "",
            assignJobLocationId: "",
            expandedApplicationId: null,
            searchText: "",
            filterJobLocationId: "",
            page: 0,
            rowsPerPage: 20,
            availableFieldLocations: [],
            rosterByApplication: {},
            punchStatusByUserId: {},
            leadsCountRows: [],
            isOpenAddRosterEntry: false,
            newRosterLocationId: "",
            newRosterStartDate: moment().format("YYYY-MM-DD"),
            newRosterEndDate: "",
        }
    }

    componentDidMount() {
        this.fetchAssignedPartners();
        this.fetchAvailableFieldLocations();
    }

    fetchAssignedPartners = async () => {
        store.dispatch(setLoader(true));
        try {
            let { searchText, filterJobLocationId } = this.state;
            let params = {
                job_id: this.props.job.job_id,
                status: "IN_TASK",
                extra_details_status: 3,
                eligibility_status: 1,
                is_starred: 1
            };
            if (searchText) params.search = searchText;
            if (filterJobLocationId) params.job_location_id = filterJobLocationId;
            let resp = await ApiEndpoints.Applicants.fetch(params);
            this.setState({ partners: resp.data.data, page: 0 });
            this.fetchPunchAndLeadsSummary();
        }
        catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }))
        }
        store.dispatch(setLoader(false))
    }

    // Bulk punch-status + leads-count for every partner on this job, so the
    // main table can show live status/counts without a per-partner call.
    fetchPunchAndLeadsSummary = async () => {
        try {
            let job_id = this.props.job.job_id;
            let [statusResp, leadsResp] = await Promise.all([
                ApiEndpoints.FieldSurveyActivity.statusByJob({ job_id }),
                ApiEndpoints.FieldSurveyLead.leadsCountByJob({ job_id })
            ]);
            let punchStatusByUserId = {};
            (statusResp.data.data || []).forEach(row => { punchStatusByUserId[row.user_id] = row; });
            this.setState({ punchStatusByUserId, leadsCountRows: leadsResp.data.data || [] });
        }
        catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }))
        }
    }

    totalLeadsForUser = (user_id) => this.state.leadsCountRows
        .filter(row => row.user_id === user_id)
        .reduce((sum, row) => sum + Number(row.leads_count), 0);

    leadsForUserAndLocation = (user_id, job_field_location_id) => {
        let match = this.state.leadsCountRows.find(row => row.user_id === user_id && row.job_field_location_id === job_field_location_id);
        return match ? Number(match.leads_count) : 0;
    }

    fetchAvailableFieldLocations = async () => {
        try {
            let resp = await ApiEndpoints.JobFieldLocation.fetch({ job_id: this.props.job.job_id });
            this.setState({ availableFieldLocations: resp.data.data });
        }
        catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }))
        }
    }

    fetchRosterForPartner = async (partner) => {
        try {
            let resp = await ApiEndpoints.JobFieldLocationRoster.fetch({ job_id: this.props.job.job_id, user_id: partner.user_id });
            this.setState(prev => ({ rosterByApplication: { ...prev.rosterByApplication, [partner.application_id]: resp.data.data } }));
        }
        catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }))
        }
    }

    assignPartner = async (e) => {
        e.preventDefault();
        let { mobile, assignJobLocationId } = this.state;
        store.dispatch(setLoader(true));
        try {
            if (mobile.toString().length !== 10) throw new Error("Mobile number should be in 10 digit format.");
            await ApiEndpoints.Applicants.assignFieldWorker({ job_id: this.props.job.job_id, mobile, job_location_id: assignJobLocationId || undefined });
            await this.fetchAssignedPartners();
            this.setState({ isOpenAssignPartner: false, mobile: "", assignJobLocationId: "" });
            store.dispatch(setSuccess({ show: true, message: "Partner assigned!" }))
        }
        catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }))
        }
        store.dispatch(setLoader(false))
    }

    toggleLocationsRow = (partner) => {
        let { expandedApplicationId } = this.state;
        if (expandedApplicationId === partner.application_id) {
            this.setState({ expandedApplicationId: null });
        } else {
            this.setState({ expandedApplicationId: partner.application_id, isOpenAddRosterEntry: false, newRosterLocationId: "", newRosterStartDate: moment().format("YYYY-MM-DD"), newRosterEndDate: "" });
            this.fetchRosterForPartner(partner);
        }
    }

    assignRosterLocation = async (partner) => {
        let { newRosterLocationId, newRosterStartDate, newRosterEndDate } = this.state;
        if (!newRosterLocationId) return;
        store.dispatch(setLoader(true));
        try {
            await ApiEndpoints.JobFieldLocationRoster.assign({
                job_id: this.props.job.job_id,
                user_id: partner.user_id,
                job_field_location_id: newRosterLocationId,
                start_date: newRosterStartDate,
                end_date: newRosterEndDate || undefined
            });
            await this.fetchRosterForPartner(partner);
            this.setState({ isOpenAddRosterEntry: false, newRosterLocationId: "", newRosterStartDate: moment().format("YYYY-MM-DD"), newRosterEndDate: "" });
            store.dispatch(setSuccess({ show: true, message: "Field Location assigned to partner!" }))
        }
        catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }))
        }
        store.dispatch(setLoader(false))
    }

    endRosterAssignment = async (partner, roster_id) => {
        store.dispatch(setLoader(true));
        try {
            await ApiEndpoints.JobFieldLocationRoster.end({ roster_id });
            await this.fetchRosterForPartner(partner);
            store.dispatch(setSuccess({ show: true, message: "Field Location unassigned." }))
        }
        catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }))
        }
        store.dispatch(setLoader(false))
    }

    cityForLocation = (job_location_id) => {
        let { job } = this.props;
        let match = (job.JobLocations || []).find(loc => loc.job_location_id === job_location_id);
        return match ? match.city : "-";
    }

    renderLocationsPanel = (partner) => {
        let { rosterByApplication, availableFieldLocations, isOpenAddRosterEntry, newRosterLocationId, newRosterStartDate, newRosterEndDate } = this.state;
        let roster = rosterByApplication[partner.application_id] || []; // already ordered start_date desc by the backend — active and past together
        let activeIds = roster.filter(isRosterActive).map(r => r.job_field_location_id);
        return (
            <div style={{ padding: 16, background: "#fafafa" }}>
                <RSButton block className="button_outline mb-2" onClick={() => this.setState({ isOpenAddRosterEntry: true })}>
                    <Icon className="align-middle mr-1" style={{ fontSize: 16 }}>add</Icon> Add Field Location
                </RSButton>
                <RSCollapse isOpen={isOpenAddRosterEntry}>
                    <Card className="mb-3 shadow-sm">
                        <CardBody>
                            <Row className="align-items-center">
                                <Col xs={4}>
                                    <SelectList placeholder="Field Location" value={newRosterLocationId} onChange={(e) => this.setState({ newRosterLocationId: e.target.value })}>
                                        {availableFieldLocations.filter(loc => !activeIds.includes(loc.job_field_location_id)).map(loc =>
                                            <option key={loc.job_field_location_id} value={loc.job_field_location_id}>{loc.location_title}</option>
                                        )}
                                    </SelectList>
                                </Col>
                                <Col xs={3}>
                                    <InputFeild type="date" placeholder="Start Date" value={newRosterStartDate} onChange={(e) => this.setState({ newRosterStartDate: e.target.value })} />
                                </Col>
                                <Col xs={3}>
                                    <InputFeild type="date" placeholder="End Date (optional)" value={newRosterEndDate} onChange={(e) => this.setState({ newRosterEndDate: e.target.value })} />
                                </Col>
                                <Col xs="auto" className="ml-auto">
                                    <RSButton className="buttonred mr-2" size="sm" onClick={() => this.assignRosterLocation(partner)}>Save</RSButton>
                                    <RSButton type="button" color="secondary" size="sm" onClick={() => this.setState({ isOpenAddRosterEntry: false })}>Cancel</RSButton>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </RSCollapse>
                <Table size="small" className="bg-white">
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ fontWeight: 600 }}>Field Location</TableCell>
                            <TableCell style={{ fontWeight: 600 }}>Assigned On</TableCell>
                            <TableCell style={{ fontWeight: 600 }}>Ended On</TableCell>
                            <TableCell style={{ fontWeight: 600 }}>Leads Added</TableCell>
                            <TableCell style={{ fontWeight: 600 }} align="right">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!roster.length ?
                            <TableRow>
                                <TableCell colSpan={5} align="center">
                                    <em style={{ color: "#999", fontSize: 12 }}>No field locations assigned yet</em>
                                </TableCell>
                            </TableRow>
                            :
                            roster.map(row => {
                                const active = isRosterActive(row);
                                return (
                                    <TableRow key={row.roster_id}>
                                        <TableCell>{row.JobFieldLocation.location_title}</TableCell>
                                        <TableCell>{moment(row.start_date).utcOffset("+05:30").format("Do MMM'YY")}</TableCell>
                                        <TableCell>{active ? <span className="text-muted" style={{ fontSize: 11 }}>Ongoing</span> : moment(row.end_date).utcOffset("+05:30").format("Do MMM'YY")}</TableCell>
                                        <TableCell>{this.leadsForUserAndLocation(partner.user_id, row.job_field_location_id)}</TableCell>
                                        <TableCell align="right">
                                            {active && <RSButton className="buttonred" size="sm" style={{ fontSize: 11, padding: "4px 10px" }} onClick={() => this.endRosterAssignment(partner, row.roster_id)}>End</RSButton>}
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                        }
                    </TableBody>
                </Table>
            </div>
        );
    }

    render() {
        let { partners, isOpenAssignPartner, mobile, assignJobLocationId, expandedApplicationId, searchText, filterJobLocationId, page, rowsPerPage } = this.state;
        let { job } = this.props;
        let pagePartners = partners.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
        return (
            <div>
                <Row className="align-items-center mb-3">
                    <Col xs="auto">
                        <RSButton className="buttonred" style={{ height: "30px", paddingTop: "4px" }} onClick={() => this.setState({ isOpenAssignPartner: true })}>
                            <Icon className="align-middle mr-1" style={{ fontSize: 16 }}>person_add</Icon> Assign Partner
                        </RSButton>
                    </Col>
                    <Col className="d-flex justify-content-end">
                        <div style={{ width: 240 }} className="mr-2">
                            <InputFeild
                                placeholder="Search by partner name"
                                value={searchText}
                                onChange={(e) => this.setState({ searchText: e.target.value })}
                                onKeyDown={(e) => { if (e.key === "Enter") this.fetchAssignedPartners(); }}
                                icon="search"
                                onClickIcon={this.fetchAssignedPartners}
                            />
                        </div>
                        <div style={{ width: 200 }}>
                            <SelectList
                                placeholder="Filter by Location"
                                selectAll="All Locations"
                                value={filterJobLocationId}
                                onChange={(e) => this.setState({ filterJobLocationId: e.target.value }, this.fetchAssignedPartners)}
                            >
                                {(job.JobLocations || []).map(loc =>
                                    <option key={loc.job_location_id} value={loc.job_location_id}>{loc.city}</option>
                                )}
                            </SelectList>
                        </div>
                    </Col>
                </Row>
                <RSCollapse isOpen={isOpenAssignPartner}>
                    <Card className="mb-3 shadow-sm">
                        <CardBody>
                            <form onSubmit={this.assignPartner}>
                                <Row className="align-items-center">
                                    <Col xs={4}>
                                        <InputFeild required name="mobile" type="number" value={mobile} onChange={(e) => this.setState({ mobile: e.target.value })} placeholder="Phone Number" />
                                    </Col>
                                    <Col xs={4}>
                                        <SelectList
                                            placeholder="Select Partner Location"
                                            value={assignJobLocationId}
                                            onChange={(e) => this.setState({ assignJobLocationId: e.target.value })}
                                        >
                                            {(job.JobLocations || []).map(loc =>
                                                <option key={loc.job_location_id} value={loc.job_location_id}>{loc.city}</option>
                                            )}
                                        </SelectList>
                                    </Col>
                                    <Col xs="auto" className="ml-auto">
                                        <RSButton className="buttonred mr-2" style={{ height: "30px", paddingTop: "4px" }}>Assign</RSButton>
                                        <RSButton onClick={() => { this.setState({ isOpenAssignPartner: false, mobile: "", assignJobLocationId: "" }) }} type="button" color="secondary" style={{ height: "30px", paddingTop: "4px" }}>Cancel</RSButton>
                                    </Col>
                                </Row>
                            </form>
                        </CardBody>
                    </Card>
                </RSCollapse>

                <Paper elevation={1}>
                    <Table size="small">
                        <TableHead>
                            <TableRow style={{ background: "#fafafa" }}>
                                <TableCell style={{ fontWeight: 600 }}>Partner</TableCell>
                                <TableCell style={{ fontWeight: 600 }}>Location</TableCell>
                                <TableCell style={{ fontWeight: 600 }}>Status</TableCell>
                                <TableCell style={{ fontWeight: 600 }}>Leads Added</TableCell>
                                <TableCell style={{ fontWeight: 600 }} align="right">Field Locations</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!pagePartners.length ?
                                <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        <em style={{ color: "#999" }}>No Gig Workers assigned yet</em>
                                    </TableCell>
                                </TableRow>
                                :
                                pagePartners.map((partner) => {
                                    const isExpanded = expandedApplicationId === partner.application_id;
                                    return (
                                        <React.Fragment key={partner.application_id}>
                                            <TableRow hover>
                                                <TableCell><UserCard data={partner.User} /></TableCell>
                                                <TableCell>
                                                    <span className="d-block">{this.cityForLocation(partner.job_location_id)}</span>
                                                    <span className="d-block text-muted" style={{ fontSize: 11, fontWeight: 300 }}>{moment(partner.modified_on).format("Do MMM'YY")}</span>
                                                </TableCell>
                                                <TableCell>
                                                    {(() => {
                                                        const status = this.state.punchStatusByUserId[partner.user_id];
                                                        return status && status.isPunchedIn
                                                            ? <span className="d-block" style={{ color: "#2e7d32", fontSize: 12, fontWeight: 600, whiteSpace: "nowrap" }}>● Punched In <br /><span className="text-muted" style={{ fontWeight: 300 }}>({moment(status.punchInTime, "YYYY-MM-DD HH:mm:ss").format("Do MMM, h:mm A")})</span></span>
                                                            : <span className="d-block text-muted" style={{ fontSize: 12 }}>○ Not Punched In</span>;
                                                    })()}
                                                </TableCell>
                                                <TableCell>{this.totalLeadsForUser(partner.user_id)}</TableCell>
                                                <TableCell align="right">
                                                    <Button size="small" variant="outlined" style={{ minWidth: "auto", whiteSpace: "nowrap", fontSize: 11, padding: "2px 8px", ...(isExpanded ? { color: "#f1061c", borderColor: "#f1061c" } : {}) }} onClick={() => this.toggleLocationsRow(partner)}>
                                                        <Icon style={{ fontSize: 14 }} className="mr-1">place</Icon>
                                                        Locations
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{ padding: 0, borderBottom: isExpanded ? undefined : "none" }} colSpan={5}>
                                                    <Collapse in={isExpanded} unmountOnExit>
                                                        {this.renderLocationsPanel(partner)}
                                                    </Collapse>
                                                </TableCell>
                                            </TableRow>
                                        </React.Fragment>
                                    );
                                })
                            }
                        </TableBody>
                    </Table>
                    <TablePagination
                        component="div"
                        count={partners.length}
                        page={page}
                        onChangePage={(e, newPage) => this.setState({ page: newPage })}
                        rowsPerPage={rowsPerPage}
                        onChangeRowsPerPage={(e) => this.setState({ rowsPerPage: parseInt(e.target.value), page: 0 })}
                        rowsPerPageOptions={[20, 40, 60, 100]}
                    />
                </Paper>
            </div>
        );
    }
}
export default ManageFieldWorkers;
